import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from "../data.service";
import { ApiService } from '../api.service';
import moment from 'moment';
import _lodash from 'lodash';

@Component({
  selector: 'app-card-transaction',
  templateUrl: './card-transaction.component.html',
  styleUrls: ['./card-transaction.component.scss']
})
export class CardTransactionComponent implements OnInit {
  cardId: any;
  cardType: any;
  actionType: any
  isSaving = false;
  isReplacing = false;
  showPageLoader = true;
  gettingTxn = false;
  panelExpanded = false;
  userData: any;
  giftCards: any = {};
  midSecHt: any;
  page = 0;
  pageSize = 10;
  initialTxnList: any = [];
  transactions: any = [];
  blockUnblockText = "Block Card";
  selectedTxn: any = {};
  moment: any = moment;
  noMoreTxnText: any;
  giftCardsImageUrl: any;
  displayTxnOnly: any = false;

  constructor(
    private dataService: DataService,
    private apiService: ApiService,
    private router: Router,
    protected activatedRoute: ActivatedRoute
  ) { }

  calculateHieght() {
    setTimeout(() => {
      let wh = window.innerHeight;
      let topSecHt = document.getElementById('topSec').offsetHeight;
      this.midSecHt = (wh - topSecHt);
    });
  };

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.cardId = +params['id'];
    });
    this.dataService.getCardType().subscribe(val => {
      if (val) {
        this.cardType = val;
      }
    });
    this.getCardTransactions();
    this.calculateHieght();
  }

  previousState() {
    window.history.back();
  };

  getTxnTimeToDisplay(txnTime: any, txnDate: any) {
    let timeDispText = ''
    if (txnTime >= (7 * 24 * 60)) {
      let daycount = Math.floor((txnTime / (24 * 60)))
      timeDispText = moment(txnDate).format('DD/MM/YYYY')
    } else if (txnTime >= (24 * 60) && txnTime < (7 * 24 * 60)) {
      timeDispText = Math.floor((txnTime / (24 * 60))) + 'd ago';
    } else if (txnTime >= (60) && txnTime < (24 * 60)) {
      timeDispText = Math.floor((txnTime / (60))) + 'h ago';
    } else if (txnTime < 60) {
      timeDispText = txnTime + 'm ago'
    }
    return timeDispText;
  }

  getTxnTypeIcon(item: any) {
    if (item.transactionableType) return `./../../assets/img/${item.transactionableType}.png`
    else return './../../assets/img/SPEND.png';
  }

  gettxnIconColour(item) {
    if (item.transactionableType === 'RECOVERY') return '#ffe7c1';
    else if (item.transactionableType === 'REVERSAL') return '#c4ffc9';
    else if (item.transactionableType === 'REFUND') return '#c4ffc9';
    else if (item.transactionableType === 'AUTO_RECTIFICATION') return '#c4ffc9';
    else if (item.transactionableType === 'LOAD') return '#cbb6f5';
    else if (item.transactionableType === 'SPEND') return '#e0edf5';
    else if (item.transactionableType === 'HOLD_SETTLEMENT') return '#e0edf5';
  }

  getDisplayDetail(item: any) {
    item.displayDetail = !item.displayDetail
  }

  logOut() {

    this.apiService.logOut();
    this.panelExpanded = false;
  }

  getCardTransactions() {
    this.gettingTxn = true;
    this.noMoreTxnText = '';
    const apiData = {
      "apiType": "get",
      "apiExt": `giftCards/card-transactions?giftCardUserId=${this.cardId}&page=${this.page}&size=${this.pageSize}&sort=id,desc`,
    };
    this.apiService.customGetApiCall({}, apiData).then((res: any) => {
      if (res && res.data && res.data.content && res.data.content.length > 0) {
        this.processAfterTxnGet(res.data.content)
      } else {
        if (this.page > 0) {
          this.page = this.page - 1;
          this.noMoreTxnText = "No more Transactions available!"
        } else this.noMoreTxnText = "No Transactions available!"
        this.gettingTxn = false;
      }
    },
      (error) => {
        this.gettingTxn = false;
      });
  }

  processAfterTxnGet(res: any) {
    if (this.page == 0) {
      this.initialTxnList = _lodash.cloneDeep(res);
      this.transactions = this.initialTxnList;
    }
    else this.transactions = this.transactions.concat(res)
    this.gettingTxn = false;
  }

  onScroll() {
    this.showPageLoader = false;
    this.page = this.page + 1;
    this.getCardTransactions()
  }
}
